import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/AuthLayout';
import MainLayout from './layouts/main/MainLayout';
import LoginPage from './pages/LoginPage';
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import DashboardPage from './pages/DashboardPage';
import AdminList from './pages/admin/List';
import CompanyList from './pages/company/List';
import SubAdminList from './pages/subAdmin/List';
import CustomerList from  './pages/customer/List';
import DeviceList from './pages/customer/devices/List';
import LogsList from './pages/customer/logs/List';
import BulkMessage from './pages/customer/bulk/BulkMessage';
import BatchList from './pages/customer/bulk/BatchList';
import BatchDetailsList from './pages/customer/bulk/BatchDetailsList';
import ProfilePage from './pages/ProfilePage';
import CustomerUsage from './pages/reports/usage/CustomerUsage';

const App = () => {
  return (
    <Routes>
      {/* Auth Routes (Public) */}
      <Route element={<PublicRoute><AuthLayout /></PublicRoute>}>
        <Route path="/login" element={<LoginPage />} />
      </Route>
      
      {/* Protected Routes (Private) */}
      <Route element={<PrivateRoute/>}>
        {/* Example protected route */}
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/admin/list" element={<AdminList />} />
        <Route path="/company/list" element={<CompanyList />} />
        <Route path="/sub-admin/list" element={<SubAdminList />} />
        <Route path="/customer/list" element={<CustomerList />} />
        <Route path="/:id/customer/list" element={<CustomerList />} />
        <Route path="/customer/device/list" element={<DeviceList />} />
        <Route path="/customer/logs/list" element={<LogsList />} />
        <Route path="/customer/bulk/message" element={<BulkMessage />} />
        <Route path="/customer/batch/list" element={<BatchList />} />
        <Route path="/customer/batch-details/:batchId" element={<BatchDetailsList />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/reports/customer_last_usaage" element={<CustomerUsage />} />
        {/* Add more protected routes below */}
      </Route>

      {/* Fallback Route */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default App;